import React from 'react';

import MapControl from 'ui/Map/MapControl';
import { ControlPosition } from 'ui/Map/MapControl/types';
import MapTypeControl from 'ui/Map/MapTypeControl';
import FullScreenControl from 'ui/Map/FullScreenControl';
import LocateControl from 'ui/Map/LocateControl';

import ZoomControl from 'components/Map/ZoomControl';

import { PositionProps } from '../../types';

const arePropsEqual = (prevProp: PositionProps, nextProp: PositionProps): boolean =>
  prevProp.position.lng === nextProp.position.lng && prevProp.position.lat === nextProp.position.lat;

const MapControls: React.FunctionComponent<PositionProps> = ({ position }) => (
  <>
    <MapControl position={ControlPosition.TOP_LEFT}>
      <MapTypeControl />
    </MapControl>
    <MapControl position={ControlPosition.TOP_RIGHT}>
      <FullScreenControl />
    </MapControl>
    <MapControl position={ControlPosition.RIGHT_BOTTOM}>
      <LocateControl location={position} />
      <ZoomControl />
    </MapControl>
  </>
);

export default React.memo(MapControls, arePropsEqual);
